export const SKILL_LEVELS = {
  1: { label: 'Niveau 1', shortLabel: 'N1', color: '#ff9800' }, // Orange
  2: { label: 'Niveau 2', shortLabel: 'N2', color: '#4caf50' }  // Vert
};

export const SKILL_LEVEL_OPTIONS = [
  { value: 1, label: 'Niveau 1', shortLabel: 'N1' },
  { value: 2, label: 'Niveau 2', shortLabel: 'N2' }
];

export const getSkillLevelLabel = (level) => {
  return SKILL_LEVELS[level]?.label || `Niveau ${level}`;
};

export const getSkillLevelShortLabel = (level) => {
  return SKILL_LEVELS[level]?.shortLabel || `N${level}`;
};

export const getSkillLevelColor = (level) => {
  return SKILL_LEVELS[level]?.color || '#757575';
};